export const ConstantText = {
  REQUEST_NEW_CONNECTIONS: 'Request new connection',
  ARE_WE_MISSING: 'Are we missing something you want added?',
  SAME_NAME: 'This name already exists. Please try another one.',
  FILL_FIELD: 'Please fill in this field',
  ARCHIVE_CONNECTION_1:
    'You are about to archive this connection. This may impact your operations. Please note that this action is reversible.',
  ARCHIVE_CONNECTION_2: 'Are you sure you want to archive this connection?',
  ERROR_ARCHIVE: "Couldn't archive this connection. Please, try again.",
  CORRECT_ARCHIVE: (archive) =>
    `Connection successfully ${archive ? 'archive' : 'activate'}.`,
  ACTIVATE_CONNECTION_1: 'You are about to activate this connection.',
  ACTIVATE_CONNECTION_2: 'Are you sure you want to activate this connection?',
  ACTIVATE_CHECKOUT_1:
    'To archive a connection you must not have its functionalities published in Checkout builder and Routing.',
  ACTIVATE_CHECKOUT_2:
    'Please check these settings and once they are resolved you will be able to resume archiving the connection.',
  CONNECTION_FAILED:
    'Oops... It looks like you already have a connection with these characteristics in your account. Please check the form fields again.',
  TITLE_CONNECTION_FAILED: 'Connection attempt failed',
  ERROR_MESSAGE_NAME: 'DUPLICATE_CONNECTION',
  CONNECTION_ALREADY_EXISTS: 'CONNECTION_ALREADY_EXISTS',
  CONNECTION_EDITED: 'Connection successfully edited.',
  CONNECTION_EDITED_ERROR: "Couldn't edit this connection. Please, try again.",
  CONNECTIONS_ERROR_PROVITIONAL: 'Connection already exists',
  CONNECTION_CHILD_TITLE: 'Connection request issued',
  CONNECTION_CHILD_DESCRIPTION:
    'You have successfully issued your connection request. Please note that it will take up to 4 hours for this connection to be enabled. You will receive a notification once we have a resolution.',
  CONNECTION_TOOLTIP_TITLE:
    'We are validating the data for this connection. Remember that we can take up to 4 hours from your request.',
  DELETE_DIALOG_1:
    'You are about to delete this connection. Please note that this action is irreversible.',
  DELETE_DIALOG_2: 'Are you sure you want to delete this connection?',
  CONNECTION_DELETE: 'Connection successfully deleted.',
  CONNECTION_NOT_DELETE: "Couldn't delete this connection. Please, try again.",
  CONNECT_DEFAULT: 'No, only apply to the current account.',
  CONFIRM_ACCOUNTS_1: (accountName) =>
    `The changes will be applied to ${accountName} account. Would you like to apply them to other accounts as well?`,
  CONFIRM_ACCOUNTS_2:
    'Please note that the changes will only apply to the navigation mode you are in.',
  SELECT_YOUR_OPTIONS: 'Select your options',
  APPLY_MULTIPLE_ACCOUNTS: 'Apply to multiple accounts',
  SAVE_CHANGES: 'Save changes',
  CONFIRM: 'Confirm',
  TRY_AGAIN: 'Try again',
  CONNECTION_FAILED_MULTI:
    'Oops... It looks like you already have a connection with these characteristics in your account. Please check the form fields again.',
  COPIED_CLIPBOARD: 'Connection ID copied to clipboard.',
  COPIED_CLIPBOARD_TEXT: 'Copy connection ID',
  MERCADO_PAGO_CHECKOUT_PRO: 'MERCADO_PAGO_CHECKOUT_PRO',
  TEST_CREDENTIALS: 'Use our test credentials to connect faster and easier.',
  TEST_YUNO_CREDENTIALS: 'Yuno credentials',
  ENABLED_PAYMENT_METHODS: 'ENABLED_PAYMENT_METHODS',
  WEB_PAY_PLUS: 'WebPay Plus',
  WEB_PAY_PLUS_MALL: 'WebPay Plus Mall',
  OPTIONAL: ' (optional)'
}

export const providerLocationCoverage = {
  WOMPI: 'GLOBAL',
  DLOCAL: 'GLOBAL',
  MERCADO_PAGO: ['AR', 'BR', 'CO', 'CL', 'MX', 'PE', 'UY'],
  ADDI: ['BR', 'CO'],
  SPINPAY: 'GLOBAL',
  ACUOTAZ: 'GLOBAL',
  CLEAR_SALE: 'GLOBAL',
  SAFETYPAY: 'GLOBAL',
  PAYU: 'GLOBAL',
  WIBOND: 'GLOBAL',
  DAVIPLATA: 'GLOBAL',
  PAYPAL: 'GLOBAL',
  PAYMENTEZ: [
    'AR',
    'BR',
    'CL',
    'CO',
    'CR',
    'EC',
    'SV',
    'GT',
    'HN',
    'MX',
    'NI',
    'PA',
    'PE',
    'UY',
  ],
  BAC: ['CR', 'SV', 'GT', 'HN', 'NI', 'PA'],
  FAC: [
    'AW',
    'CW',
    'DO',
    'TT',
    'DO',
    'CR',
    'SV',
    'GT',
    'HN',
    'NI',
    'PA',
    'AI',
    'AG',
    'BS',
    'BB',
    'BZ',
    'BM',
    'VG',
    'KY',
    'DM',
    'GD',
    'GY',
    'JM',
    'MS',
    'KN',
    'LC',
    'SX',
    'VC',
    'TC',
  ],
  ADYEN: 'GLOBAL',
  ARCUS: 'MX',
  TRANSBANK: 'CL',
  BAC_CREDOMATIC: ['CR', 'SV', 'GT', 'HN', 'NI', 'PA'],
  PAGSEGURO: ['CO', 'BR', 'CL', 'AR'],
}

export const countryNames = {
  AF: 'Afghanistan',
  AX: 'Åland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  'ES-CT': 'Catalonia',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, the Democratic Republic of the',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Côte d'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  EU: 'European Union',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: "Korea, Democratic People's Republic of",
  KR: 'Korea, Republic of',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia, the Former Yugoslav Republic of',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States of',
  MD: 'Moldova, Republic of',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine, State of',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan, Province of China',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  'GB-ENG': 'England',
  'GB-NIR': 'Northern Ireland',
  'GB-SCT': 'Scotland',
  'GB-WLS': 'Wales',
  UN: 'United Nations',
  US: 'United States',
  UM: 'United States Minor Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela, Bolivarian Republic of',
  VN: 'Viet Nam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
}

export const capabilitiesData = {
  'Buy Now Pay Later': {
    text: 'Buy Now Pay Later',
    icon: 'Bag',
  },
  Payments: {
    text: 'Payments',
    icon: 'CurrencyCircleDollar',
  },
  Enrollment: {
    text: 'Enrollment',
    icon: 'Key',
  },
}

export const textSetupInstructionDescription = (providerName: string) =>
  `Complete the following setups within the ${providerName} dashboard to complete your connection.`

export const textSearch = (text): string =>
  text.replace(/\s+/g, '').toLowerCase()

const ITEM_HEIGHT = 58
const ITEM_PADDING_TOP = 8
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
}

export const yunoTestId = 'YUNO_TEST_PAYMENT_GW'
export const yunoTestName = 'Yuno Test Payment Gateway'

export const connectionCategory = {
  PROCESSOR: 'Processor',
  PAYMENT_METHOD: 'Payment Method'
}